<template>
  <div 
    class="position-relative pointer-on-hover"
  > 
    <img
      src="/images/icons/file_icon.svg"
      alt="ciclo"
      width="24"
      height="24"
    >
    <span
      class="position-absolute theme--text font-weight-bold font-10"
      style="bottom: -8px; left: 3px;"
    >
      {{ module.module_order }}
    </span>
  </div>
</template>

<script>
export default {
    props:{
        module: {
            required: true,
            type: Object,
        }
    }
}
</script>


